import React from "react";
import { Backdrop, CircularProgress } from "@mui/material";
import { useTranslation } from "react-i18next";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";

export interface MaskProps {
  text?: string;
  coverViewport?: boolean;
  withoutText?: boolean;
}

const Mask: React.FC<MaskProps> = ({ text, coverViewport = true, withoutText = false }) => {
  const { t } = useTranslation();
  return (
    <Backdrop
      open={true}
      sx={{
        color: "#fff",
        backgroundColor: "rgba(0, 0, 0, 0.3)",
        zIndex: (theme) => theme.zIndex.drawer + 1,
        position: coverViewport ? "fixed" : "absolute"
      }}
    >
      <CircularProgress color="primary" />
      {!withoutText && (
        <Box
          top={60}
          left={0}
          bottom={0}
          right={0}
          display="flex"
          alignItems="center"
          justifyContent="center"
          position="absolute"
        >
          <Typography variant="body1">{text ? text : t("main.pleaseWait")}</Typography>
        </Box>
      )}
    </Backdrop>
  );
};

export default Mask;
